module.exports = __webpack_public_path__ + "static/media/KD.658998b1.svg";